import type React from 'react'
import type { KeyboardEvent } from 'react'

import { replaceArrow } from '@/utils/replaceArrow'

type Props = {
  value: string
  className?: string
  onUpdate: (value: string) => void
  onChange: (value: string) => void
}

export const Input: React.FC<Props> = ({
  value,
  className,
  onUpdate,
  onChange,
}) => {
  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = replaceArrow(event.target.value)
    onChange(value)
  }

  const onKeyPress = (event: KeyboardEvent) => {
    if (event.which === 13) {
      onUpdate(value)
    }
  }

  return (
    <input
      type="text"
      ref={(el) => {
        el?.focus()
      }}
      maxLength={30}
      value={value}
      className={className}
      onKeyPress={onKeyPress}
      onChange={handleOnChange}
      onFocus={({ target }) => {
        target.selectionStart = 0
        target.selectionEnd = 1000
      }}
    />
  )
}
